import { render, staticRenderFns } from "./SLProfileDetail.vue?vue&type=template&id=40cbf4c4"
import script from "./SLProfileDetail.vue?vue&type=script&lang=js"
export * from "./SLProfileDetail.vue?vue&type=script&lang=js"
import style0 from "./SLProfileDetail.vue?vue&type=style&index=0&id=40cbf4c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports